import React from 'react';

const Southcarolina = () => {
  return (
    <div>
      
    </div>
  );
}

export default Southcarolina;
